import * as types from '../mutation-types'
import termService from '../../services/terms'

const state = {
    loading: false,
    errors: null,
    terms: []
}

const actions = {
    getAll({ commit }) {
        commit(types.TERM_LOADING, true)
        termService.getAll().then(
            response => {

                commit(types.LOAD_TERMS, response.data)
                commit(types.TERM_LOADING, false)
                commit(types.TERM_FAILURE, null)
            },
            error => {
                commit(types.TERM_FAILURE, error)
                commit(types.TERM_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.TERM_LOADING, true)
        commit(types.TERM_FAILURE, null)
        termService.add(data).then(
            response => {
                data.id = response.data.id
                commit(types.ADD_TERM, data)
                commit(types.TERM_LOADING, false)

            },
            error => {
                commit(types.TERM_FAILURE, error)
                commit(types.TERM_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.TERM_LOADING, true)
        commit(types.TERM_FAILURE, null)
        termService.update(data.term)
            .then(
                response => {
                    commit(types.UPDATE_TERM, data)
                    commit(types.TERM_LOADING, false)
                },
                error => {
                  console.log(error)
                    commit(types.TERM_FAILURE, error)
                    commit(types.TERM_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.TERM_LOADING, true)
        commit(types.TERM_FAILURE, null)
        termService.delete(data.term.id)
            .then(
                response => {

                    commit(types.DELETE_TERM, data)
                    commit(types.TERM_LOADING, false)

                },
                error => {
                    commit(types.TERM_FAILURE, error)
                    commit(types.TERM_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_TERM](state, payload) {
        state.terms.unshift(payload);
    },
    [types.LOAD_TERMS](state, payload) {
        state.terms = payload
    },
    [types.UPDATE_TERM](state, payload) {
        Object.assign(state.terms[payload.index], payload.term);
    },
    [types.DELETE_TERM](state, payload) {
        state.terms.splice(payload.index, 1)
    },
    [types.TERM_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.TERM_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    TERMS: state => {
        return state.terms
    },

    TERM_ERROR: state => {
        return state.errors
    },

    TERM_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/terms.js